angular.module('menuUtils', ['config'])
